'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
export interface ModalConfig {
  id: string;
  component: ReactNode;
  title?: string;
  description?: React.ReactNode;
  showCloseButton?: boolean;
  onClose?: () => void;
  className?: string;
  fullscreenOnMobile?: boolean;
  preventAutoFocus?: boolean;
}
interface ModalContextType {
  modals: ModalConfig[];
  showModal: (config: Omit<ModalConfig, 'id'>) => string;
  hideModal: (id: string) => void;
  hideAllModals: () => void;
}
const ModalContext = createContext<ModalContextType | null>(null);
export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
}
interface ModalProviderProps {
  children: ReactNode;
}
export function ModalProvider(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [modals, setModals] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = config => {
      const id = Math.random().toString(36).substr(2, 9);
      const modalConfig = {
        ...config,
        id
      };
      setModals(prev => [...prev, modalConfig]);
      return id;
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const showModal = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = id_0 => {
      setModals(prev_0 => {
        const modal = prev_0.find(m => m.id === id_0);
        if (modal?.onClose) {
          modal.onClose();
        }
        return prev_0.filter(m_0 => m_0.id !== id_0);
      });
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const hideModal = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setModals(_temp2);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const hideAllModals = t4;
  let t5;
  if ($[4] !== modals) {
    t5 = {
      modals,
      showModal,
      hideModal,
      hideAllModals
    };
    $[4] = modals;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const value = t5;
  let t6;
  if ($[6] !== children || $[7] !== value) {
    t6 = <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
    $[6] = children;
    $[7] = value;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp2(prev_1) {
  prev_1.forEach(_temp);
  return [];
}
function _temp(modal_0) {
  if (modal_0.onClose) {
    modal_0.onClose();
  }
}